import { render, staticRenderFns } from "./AddProviderContact.vue?vue&type=template&id=9aac2954"
import script from "./AddProviderContact.vue?vue&type=script&lang=js"
export * from "./AddProviderContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports